// extracted by mini-css-extract-plugin
export default {"titleRender":"RenderCardTitle_titleRender__xFEfJ","buttonImage":"RenderCardTitle_buttonImage__VAZRG","image":"RenderCardTitle_image__LXQNX"};